import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useRef, useState } from "react";

import { UserContext } from "../contexts";
import {
  Home,
  IconName,
  Series,
} from "../types";
import { getPriceFormatted } from "../util";
import Rendivo from "../util/rendivo";
import Carousel from "./Carousel";
import Icon from "./Icon";

// @ts-ignore
const SeriesListing = observer(
  (props: {
    series: Series;
    isActive: boolean;
  }) => {
    const [selectedHome, setSelectedHome] = useState<Home | null>(null);
    const userContext = useContext(UserContext);

    useEffect(() => {
      if(props.series.homes){
        setSelectedHome(props.series.homes[0]);
      }
    }, []);

    useEffect(() => {
      if(selectedHome){
        userContext.setSelectedHome(selectedHome);
      }
    }, [
      selectedHome
    ]);

    const onSlide = (index: number) => {
      //Do Nothing
    };

    return (
      <div
        className="pyht-series-listing"
      >
        <div className="details">
          <h2 className="series-title">{ props.series.title } Series</h2>
          <div className="tabs-price">
            {props.series.homes && (
              <div className="tabs">
                {props.series.homes.map((home) => {
                  return (
                    <div key={home.id} 
                      data-id={home.id} 
                      className={`tab ${selectedHome && selectedHome.id == home.id ? "active" : "" }`}
                      onClick={() => setSelectedHome(home)}
                    >
                      { home.title.replace(props.series.title + " ", "").replace(" Narrow", "N").replace(" Dual", "D") }
                    </div>
                  );
                })}
              </div>
            )}
            {selectedHome && (
              <div className="price">
                <span className="from">From </span>
                {getPriceFormatted(selectedHome.price)}
              </div>
            )}
          </div>
          {selectedHome && (
            <>
              <div className="rooms">
                <div className={"room"}>
                  <Icon name={IconName.BED} />
                  <span>{selectedHome.bedrooms}</span>
                </div>
                <div className={"room"}>
                  <Icon name={IconName.COUCH} />
                  <span>{selectedHome.living_areas}</span>
                </div>
                <div className={"room"}>
                  <Icon name={IconName.BATH} />
                  <span>{selectedHome.bathrooms}</span>
                </div>
                <div className={"room"}>
                  <Icon name={IconName.CAR} />
                  <span>{selectedHome.car_spaces}</span>
                </div>
                <div className={"room"}>
                  <Icon name={IconName.LOT_WIDTH} />
                  <span>{selectedHome.lot_width}</span>
                </div>
              </div>
              <div className="dimensions">
                <div className="h6 dimensions-title">House Dimensions</div>
                <div className="dimension">
                  <div className="label">Area</div>
                  <div className="value">{selectedHome.total_area_m}m&sup2;</div>
                </div>
                <div className="dimension">
                  <div className="label">Length</div>
                  <div className="value">{selectedHome.length}m</div>
                </div>
                <div className="dimension">
                  <div className="label">Width</div>
                  <div className="value">{selectedHome.width}m</div>
                </div>
              </div>
              <div className="btn">Select { props.series.title }</div>
            </>
          )}
        </div>
        <div className="floorplan">
          <div className="floorplan-inner">
            {selectedHome && (
              <img src={selectedHome.floorplan_image}></img>
            )}
          </div>
        </div>
        <div className="facades">
          {selectedHome && (
            <Carousel
              onSlide={onSlide}
              hidePagination
              itemWidthPerc={100}
              spacingPx={0}
              className="facades-carousel"
              disableSwipe={true}
              items={selectedHome.facades.map((image, index) => {
                return (
                  <div className={"slide"} key={index}>
                    <div className="slide-image">
                      <img src={Rendivo.getFacadeFinishRender(700,image.rendivo_id,null,"",false)} />
                    </div>
                    <div className="slide-title">{ image.title } Facade</div>
                  </div>
                );
              })}
            />
          )}
        </div>
      </div>
    );
  }
);

export default SeriesListing;
